<tui-root [attr.tuiTheme]="themeMode">
  <router-outlet></router-outlet>
</tui-root>

<app-testing-control *ngIf="testingControlEnabled"></app-testing-control>
